// extracted by mini-css-extract-plugin
module.exports = {"navbartypography":"AppNavBar_navbartypography__1h6It","activitynavbarfontclass":"AppNavBar_activitynavbarfontclass__khp4C"};